import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../insightConfig/insightConfig";
import "./Live_streaming.css";

function StudentLiveClass() {
    const [videoUrl, setVideoUrl] = useState("");

    useEffect(() => {
        const fetchLiveUrl = async () => {
            try {
                const res = await axios.get(BASE_URL + "/user/get-live-url");
                setVideoUrl(res.data.link); // e.g., YouTube video ID or full embed URL
            } catch (error) {
                console.error("Error fetching live URL:", error);
            }
        };
        fetchLiveUrl();
    }, []);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'PrintScreen') {
                navigator.clipboard.writeText(""); // Clear clipboard
                alert("Screenshots are disabled.");
            }
        };
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // Blur the UI or stop the video
                document.body.style.filter = "blur(25px)";
                // Logic to stop the live stream playback
            } else {
                document.body.style.filter = "none";
            }
        }
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener('keyup', handleKeyDown);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener('keyup', handleKeyDown);
        };
    }, [])

    if (!videoUrl) {
        return <p className="text-center text-gray-500 mt-4">No live class right now.</p>;
    }

    return (
        <div className="flex justify-center items-center w-full">
            <div className="main_div">
                <iframe sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation" src={` src="https://www.youtube.com/embed/RUuX-ndJ7NI?autoplay=1"`} width="100%"
                    height="100%" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
                {/* Mask only top-right 3-dot menu */}
                <div className="mask"></div>
            </div>
        </div>
    );
}

export default StudentLiveClass;
